import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, skipOnboarding = false }) {
  const { user, business, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Force fresh non-super-admin owners through the onboarding wizard
  if (!skipOnboarding && !user.is_super_admin && business && business.onboarding_completed === false) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
